export default {
  common: {
    error: "Něco se pokazilo",
    reload: "Znovu načíst",
    errorNotification: "Byli jsme informováni a opravíme to co nejdříve. Pokud problém přetrvává, prosím",
    contactUs: "kontaktujte nás.",
    language: "Jazyk",
    loading: "Načítání...",
    loadingText: "Načítání",
    save: "Uložit",
    savedSuccessfully: "Úspěšně Uloženo",
    saving: "Ukládání...",
    cancel: "Zrušit",
    edit: "Upravit",
    delete: "Smazat",
    add: "Přidat",
    search: "Hledat",
    filter: "Filtr",
    clear: "Vymazat",
    preview: "Náhled",
    default: "Výchozí: {{value}}",
    optional: "Volitelné",
    required: "Povinné",
    noData: "Žádná data",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Lokality",
      cities: "Města", 
      regions: "Regiony",
      countries: "Země",
      showOnMap: "Zobrazit na mapě",
      addLocation: "Přidat lokalitu"
    },
    welcome: {
      title: "Vítejte v Locations So Super.",
      subtitle: "Vyberte sekci z navigace pro začátek."
    }
  },

  // Cities section
  cities: {
    title: "Města",
    resourceSingular: "město",
    resourcePlural: "města",
    headings: {
      name: "Název",
      status: "Stav",
      locations: "Lokality", 
      region: "Region",
      country: "Země"
    },
    breadcrumbs: {
      cities: "Města"
    }
  },

  // Countries section  
  countries: {
    title: "Země",
    resourceSingular: "země", 
    resourcePlural: "země",
    headings: {
      name: "Název",
      status: "Stav",
      locations: "Lokality",
      cities: "Města",
      regions: "Regiony"
    },
    breadcrumbs: {
      countries: "Země"
    }
  },

  // Regions section
  regions: {
    title: "Regiony",
    resourceSingular: "region",
    resourcePlural: "regiony", 
    headings: {
      name: "Název",
      status: "Stav",
      locations: "Lokality",
      cities: "Města",
      country: "Země"
    },
    breadcrumbs: {
      regions: "Regiony"
    }
  },

  // Map section
  map: {
    title: "Mapa",
    breadcrumbs: {
      locations: "Lokality"
    }
  },

  // Import section
  import: {
            title: "CSV import",
    breadcrumbs: {
      locations: "Lokality"
    },
    new: {
      title: "Import lokalit pomocí CSV",
      description: "Stáhněte si vzorovou CSV šablonu pro zobrazení příkladu požadovaného formátu",
      sampleTemplate: "vzorová CSV šablona",
      uploadAndContinue: "Nahrát a pokračovat",
      abortOnError: "Přerušit při chybě",
      abortOnErrorHelp: "Pokud dojde k chybě, import se přeruší, zobrazí chybu a žádné lokality se neimportují.",
      needHelp: "Potřebujete pomoc s importem lokalit?"
    },
    show: {
      title: "CSV import",
      youCanLeavePage: "Můžete opustit tuto stránku",
      backgroundMessage: "Váš import bude stále běžet na pozadí",
      importProgress: "Průběh importu",
      imported: "Importováno",
      suffix: "lokalit",
              importLog: "Import protokol",
      cancelImport: "Zrušit import",
      cancelConfirmation: {
        title: "Zrušit import",
        message: "Opravdu chcete zrušit tento import? Tuto akci nelze vrátit zpět.",
        note: "Poznámka: Pro probíhající úlohy se úloha musí dokončit a bude smazána hned poté.",
        yesCancel: "Ano, zrušit import",
        noContinue: "Ne, pokračovat v importu"
      },
      report: "Zpráva",
      failedLocations: "Neúspěšné lokality",
      uploadAnother: "Nahrát další CSV",
      backToLocations: "Zpět na lokality",
      importSucceeded: "Import úspěšný",
      importFailed: "Import selhal"
    },
    messages: {
      uploadSuccess: "CSV úspěšně nahráno",
      uploadError: "CSV se nepodařilo nahrát",
      pending: "Import ještě nezačal",
      inProgress: "Import probíhá",
      completed: "Import dokončen",
      invalidHeader: "Jsou vyžadovány následující sloupce",
      invalidCsvFile: "Neplatný CSV soubor",
      aborted: "Import přerušen",
      failed: "Import selhal",
      cancelled: "Import zrušen"
    },
    errors: {
      csvTooLarge: "CSV je příliš velký",
      languageNotEnabled: "Jazyk '{{language}}' není pro tento obchod povolen. Nejprve ho povolte v Nastavení > Jazyky.",
      fieldNotTranslatable: "Pole '{{field}}' není přeložitelné. Přeložitelná pole jsou: {{fields}}",
      locationError: "Lokalita se slugem: {{slug}} - {{error}}",
      planLimit: "Jste na limitu vašeho plánu pro lokality"
    }
  },

  // Location form
  location: {
    index: {
      title: "Lokality",
      addLocation: "Přidat lokalitu",
      import: "Import",
      noPrioritySet: "Není nastavena priorita",
      published: "Publikováno",
      draft: "Koncept",
      resourceSingular: "lokalita",
      resourcePlural: "lokality",
      headings: {
        name: "Název",
        status: "Stav", 
        city: "Město",
        region: "Region",
        country: "Země",
        priority: "Priorita"
      }
    },
    form: {
      title: "Přidat lokalitu",
      editTitle: "Upravit lokalitu",
      basicInformation: "Základní informace",
      name: "Název",
      namePlaceholder: "např. Brianovy cihly",
      nameHelpDefault: "Výchozí: {{defaultName}}",
      details: "Podrobnosti",
      description: "Popis",
      descriptionPlaceholder: "Řekněte zákazníkům, co dělá tuto lokalitu výjimečnou",
      address: "Adresa",
      addressPlaceholder: "123 Hlavní ulice, Město, Země",
      addressLine1: "Řádek adresy 1",
      addressLine2: "Řádek adresy 2",
      postalZipCode: "PSČ",
      city: "Město",
      stateProvinceRegion: "Kraj / Provincie / Region",
      country: "Země",
      phone: "Telefon",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "E-mail", 
      emailPlaceholder: "obchod@priklad.com",
      website: "Webové stránky",
      websitePlaceholder: "https://www.priklad.com",
      image: "Obrázek",
      imagePlaceholder: "Zadejte URL obrázku",
      status: "Stav",
      statusActive: "Aktivní",
      statusInactive: "Neaktivní",
      statusDraft: "Koncept",
      priority: "Priorita",
      priorityHelpText: "Lokality s vyšší prioritou se zobrazují první ve výsledcích vyhledávání",
      findOnMapButton: "Najít na mapě"
    },
    validation: {
      addressNotFound: "Adresu se nepodařilo najít",
      createSuccess: "Lokalita byla úspěšně vytvořena", 
      updateSuccess: "Lokalita byla úspěšně aktualizována",
      checkFields: "Prosím zkontrolujte vaše pole",
      findOnMap: "Prosím najděte vaši lokalitu na mapě před uložením"
    },
    errors: {
      loading: "Chyba při načítání lokality"
    },
    actions: {
      save: "Uložit lokalitu",
      delete: "Smazat lokalitu",
      preview: "Náhled"
    },
    customFields: {
      title: "Vlastní pole",
      noCustomFields: "Žádná vlastní pole nejsou nakonfigurována",
      configureFields: "Nakonfigurovat pole",
      emptyState: "Zatím jste nenakonfigurovali žádná vlastní pole. Vlastní pole vám umožňují přidat dodatečné informace specifické pro vaše obchodní potřeby."
    },
    openingHours: {
      title: "Otevírací doba",
      checkboxLabel: "Tato lokalita má otevírací a zavírací dobu",
      statusOpen: "Otevřeno",
      statusOpen24h: "Otevřeno 24H",
      statusClosed: "Zavřeno",
      openingTimeLabel: "Otevírací doba",
      closingTimeLabel: "Zavírací doba",
      days: {
        monday: "Pondělí",
        tuesday: "Úterý", 
        wednesday: "Středa",
        thursday: "Čtvrtek",
        friday: "Pátek",
        saturday: "Sobota",
        sunday: "Neděle"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Nedávno přidané",
        recentlyModified: "Nedávno upravené"
      },
      filters: {
        status: "Stav",
        taggedWith: "Označené tagem",
        locationStatus: "Stav lokality",
        noTagsToShow: "Žádné tagy k zobrazení",
        searchPlaceholder: "Hledat"
      },
      bulkActions: {
        setPublished: "Nastavit jako publikované",
        setUnpublished: "Nastavit jako nepublikované", 
        setPriority: "Nastavit prioritu",
        deleteLocations: "Smazat lokality",
        exportCSV: "Exportovat jako CSV"
      },
      appliedFilters: {
        statusIs: "Stav je {{status}}",
        taggedWith: "Označené tagem {{tag}}",
        nameIncludes: "Název obsahuje {{search}}"
      },
      modals: {
        deleteTitle: "Smazat lokality",
        deleteMessage: "Opravdu chcete smazat {{count}}?",
        deleteMessageAll: "Opravdu chcete smazat všechny lokality?",
        prioritiseTitle: "Prioritizovat {{count}} lokalit",
        prioritiseTitleAll: "Prioritizovat všechny lokality",
        delete: "Smazat",
        cancel: "Zrušit"
      },
      emptyState: {
        noResultsHeading: "Nepodařilo se najít žádné {{resourcePlural}}",
        noResultsText: "Zkuste změnit filtry nebo vyhledávací termín",
        noDataHeading: "Přidejte lokalitu pro naplnění {{resourcePlural}}",
        addLocation: "Přidat lokalitu",
        importFromCSV: "Import z CSV"
      },
      pagination: {
        label: "Stránka {{page}} z {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Úspěšně aktualizováno",
        deletedSuccessfully: "Úspěšně smazáno", 
        exportedSuccessfully: "Úspěšně exportováno",
        error: "Něco se pokazilo"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Obsah stránky",
    editTemplate: "Upravit SEO šablonu", 
    pageTitle: "Název",
    pageDescription: "Popis",
    metaTitle: "Název",
    metaDescription: "Popis",
    urlHandle: "URL adresa",
    searchEnginePreview: "Náhled výpisu vyhledávače",
    editMeta: "Upravit Meta",
    previewMeta: "Náhled Meta",
    loading: "Načítání...",
    editingLocaleHelp: "Úprava obsahu {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO šablony",
    breadcrumbs: {
      seoTemplates: "SEO šablony"
    },
    template: {
      title: "{{templateName}} šablona - {{locale}}",
      discardChanges: "Zahodit změny"
    },
    form: {
      pageContent: "Obsah stránky",
      searchEnginePreview: "Náhled výpisu vyhledávače",
      title: "Název",
      description: "Popis",
      pageTitle: "Název stránky",
      metaDescription: "Meta popis",
      editingLocaleHelp: "Úprava překladů {{locale}}. Prázdná pole zobrazí obsah z {{defaultLocale}}.",
      defaultValue: "Výchozí: {{value}}"
    },
    language: {
      label: "Jazyk",
      defaultHelp: "Toto je váš výchozí jazyk",
      editingHelp: "Úprava překladů {{locale}}. Prázdná pole zobrazí obsah {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "Více jazyků není povoleno",
      enableInSettings: "Povolit v nastavení",
      multipleLanguagesInfo: "Pro správu SEO šablon pro více jazyků povolte internacionalizaci v nastavení jazyků. Aktuálně se zobrazují pouze šablony {{locale}}."
    },
    badges: {
      errors: "Chyby!",
      unsaved: "Neuložené"
    },
    messages: {
      saveSuccess: "SEO šablony byly úspěšně uloženy",
      saveError: "Šablony se nepodařilo uložit",
      error: "Chyba..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Základní informace",
      name: "Název",
      save: "Uložit",
      saving: "Ukládání...",
      cancel: "Zrušit",
      yourLocationsIn: "Vaše lokality v {{name}}",
      tableHeadings: {
        name: "Název",
        status: "Stav",
        city: "Město",
        region: "Region",
        country: "Země"
      },
      resourceName: {
        singular: "{{name}} lokalita",
        plural: "lokality v {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Mapa",
      tags: "Tagy",
      customFields: "Vlastní pole",
      languages: "Jazyky",
      plan: "Plán",
      addTag: "Přidat tag",
      addField: "Přidat pole"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Brzy končí"
    },
    common: {
      loading: "Načítání...",
      error: "Chyba...",
      breadcrumbs: {
        settings: "Nastavení"
      },
      skeleton: {
        customFields: "Vlastní pole",
        addField: "Přidat pole",
        name: "Název",
        contentType: "Typ obsahu",
        usedIn: "Použito v",
        field: "Pole",
        fields: "Pole"
      },
      messages: {
        savedSuccessfully: "Nastavení {{setting}} bylo úspěšně uloženo",
        couldntSave: "Nepodařilo se uložit nastavení {{setting}}"
      }
    },
    map: {
      title: "Mapa",
      messages: {
        savedSuccessfully: "Nastavení mapy bylo úspěšně uloženo",
        couldntSave: "Nepodařilo se uložit nastavení"
      },
      mapboxToken: {
        title: "Mapbox token",
        description: "Zadejte svůj Mapbox token pro napájení vašeho vyhledávače obchodů",
        label: "Mapbox token",
        placeholder: "Zadejte token zde pro pokračování v používání vaší mapy.",
        placeholderManaged: "Zadejte token zde pro pokračování v používání vaší mapy, jakmile vyčerpáte bezplatné načítání map.",
        helpText: "Sledujte naše pokyny pro vytvoření Mapbox klíče, pak vložte svůj klíč výše. Pokud narazíte na problémy, kontaktujte nás pro pomoc.",
        linkInstructions: "pokyny pro vytvoření Mapbox klíče",
        linkSupport: "kontaktujte nás pro pomoc"
      },
      managedToken: {
        title: "Načítání map",
        description: "Máte až {{max}} bezplatných načítání map s řízeným tokenem, poté budete muset vytvořit vlastní token."
      },
      appearance: {
        title: "Vzhled",
        description: "Změňte vizuální stránku vaší mapy"
      },
      mapStyle: {
        title: "Styl mapy",
        options: {
          streets: "Ulice",
          outdoors: "Venkovní", 
          light: "Světlý",
          dark: "Tmavý",
          satellite: "Satelit",
          satelliteStreets: "Satelitní ulice",
          navigationDay: "Navigace den",
          navigationNight: "Navigace noc"
        }
      },
      searchBehaviour: {
        title: "Chování vyhledávání",
        description: "Ovládá, jak návštěvníci najdou lokality na vaší mapě.",
        geolocateLabel: "Automaticky odhadnout polohu návštěvníka a zobrazit blízké obchody",
        geolocateHelp: "Pokud geolokace uspěje, mapa se přesune zaostřit blízko návštěvníka. Pokud nelze najít odhadovanou polohu, mapa zůstane na výchozí pozici.",
        filterBehaviour: {
          title: "Chování filtru",
          all: {
            label: "Všechny tagy",
            help: "Aby se lokalita zobrazila ve filtrech, musí mít všechny vybrané tagy"
          },
          any: {
            label: "Jakékoliv tagy", 
            help: "Aby se lokalita zobrazila ve filtrech, může mít jakýkoliv z vybraných tagů"
          }
        },
        keepSearchInView: {
          label: "Zachovat vyhledávací značku v zorném poli",
          help: "Když se objeví výsledky vyhledávání, mapa se oddálí, aby zobrazila všechny odpovídající lokality"
        },
        distanceUnits: {
          title: "Jednotky vzdálenosti",
          km: "Kilometry",
          miles: "Míle"
        },
        maxResults: {
          label: "Max výsledků",
          help: "Omezit počet lokalit zobrazených ve výsledcích vyhledávání",
          options: {
            results30: "30 výsledků"
          }
        },
        maxDistance: {
          label: "Max vzdálenost", 
          help: "Zobrazit pouze lokality v této vzdálenosti od vyhledávacího bodu",
          options: {
            unlimited: "Neomezeno"
          }
        },
        showLocationNames: {
          label: "Zobrazit názvy lokalit v návrzích",
          help: "Zobrazit názvy lokalit ve vyhledávacích návrzích"
        },
        sortByPriority: {
          label: "Řadit podle priority místo vzdálenosti",
          help: "Důrazně doporučujeme nastavit maximální vzdálenost (která není Neomezená), pokud je toto políčko zaškrtnuto. Jinak uvidí vaši zákazníci vzdálené lokality s vysokou prioritou uvedené nad těmi, které jsou v rozumné vzdálenosti od nich (nebo jejich vyhledávacího dotazu, konkrétněji)."
        }
      },
      searchResults: {
        title: "Výsledky vyhledávání",
        description: "Ovládá, jak se lokality vracejí na vaší mapě.",
        locationsLabel: "Text výsledků vyhledávání",
        locationsHelp: "Text zobrazený nad výsledky vyhledávání (např. 'Zobrazuje se 5 lokalit')",
        prefixLabel: "Předpona výsledků vyhledávání", 
        prefixHelp: "Text zobrazený před počtem výsledků"
      },
      popups: {
        title: "Vyskakovací okna",
        showPopups: {
          label: "Zobrazit vyskakovací okna",
          help: "Zobrazit detaily lokality, když návštěvníci kliknou na značky mapy"
        }
             },
       whitelabel: {
         title: "Whitelabel",
         hideLabel: "Skrýt text 'powered by'",
         hideHelp: "Odstranit naše značení z vašeho vyhledávače obchodů"
       }
    },
    languages: {
      title: "Jazyky",
      error: "Chyba...",
      messages: {
        savedSuccessfully: "Jazykové nastavení bylo úspěšně uloženo",
        couldntSave: "Nepodařilo se uložit jazykové nastavení"
      },
      banner: {
        upgradeTitle: "Podpora více jazyků vyžaduje upgrade plánu",
        upgradeAction: "Upgrade na Superest",
        upgradeMessage: "Stále můžete změnit svůj výchozí jazyk, ale povolení více jazyků vyžaduje upgrade.",
        disabledMessage: "Nastavení více jazyků je na vašem současném plánu zakázáno"
      },
      defaultLanguage: {
        title: "Výchozí jazyk", 
        description: "Vyberte svůj primární jazyk, ve kterém bude váš obsah zobrazen.",
        label: "Výchozí jazyk",
        help: "Tento jazyk bude použit, když není požadován konkrétní jazyk"
      },
      internationalization: {
        title: "Internacionalizace",
        description: "Povolte více jazyků. Dosáhněte více zákazníků a zlepšete své SEO.",
        enableLabel: "Povolit více jazyků",
        enableHelp: "Umožněte zákazníkům zobrazit váš vyhledávač obchodů v různých jazycích"
      },
      supportedLanguages: {
        title: "Další podporované jazyky",
        description: "Vyberte další jazyky, které chcete podporovat. Jakmile povolíte jazyk, uvidíte možnost poskytnout překlady v celé aplikaci. Pro podporované jazyky se automaticky vygenerují výchozí SEO šablony a běžné proměnné motivy.",
        defaultLocaleNote: "Toto je váš výchozí jazyk a nelze ho zakázat",
        shopifyEnabled: {
          label: "Tento jazyk je povolen v mém Shopify obchodě",
          importantNote: "Důležité:",
          description: "Odznačte výše uvedené políčko, pokud tento jazyk není povolen a publikován pro váš Shopify obchod. Doporučujeme nejprve povolit jazyk pro váš Shopify obchod přechodem na Nastavení > Jazyky ve vašem Shopify adminu, pokud jste tak ještě neučinili, pro plynulejší zákaznickou zkušenost."
        },
        urlFormats: {
          cleanUrls: "Čisté URL:",
          betterSeo: "Lepší SEO a uživatelská zkušenost",
          queryUrls: "URL s parametrem dotazu:",
          considerEnabling: "Zvažte povolení v Shopify pro lepší URL"
        },
        preview: {
          button: "Náhled",
          tooltip: "Náhled {{language}} vyhledávače obchodů"
        },
        tooltips: {
          noTemplates: "Pro tento jazyk nejsou k dispozici žádné výchozí SEO šablony. Můžete snadno vytvořit vlastní překlady."
        }
      }
    },
    tags: {
      title: "Tagy",
      addTag: "Přidat tag",
      error: "Chyba",
      messages: {
        deletedSuccessfully: "Tagy byly úspěšně smazány",
        couldntDelete: "Tagy se nepodařilo smazat",
        savedSuccessfully: "Tag byl úspěšně uložen",
        couldntSave: "Prosím zkontrolujte svá pole",
        tagDeleted: "Tag byl úspěšně smazán"
      },
      resourceName: {
        singular: "tag",
        plural: "tagy"
      },
      filters: {
        anyGroup: "Jakákoliv skupina",
        inGroup: "Ve skupině",
        tagGroup: "Skupina tagů"
      },
      appliedFilters: {
        inGroup: "Ve skupině {{group}}",
        nameContains: "Název tagu obsahuje {{query}}"
      },
      bulkActions: {
        deleteTag: "Smazat tag",
        deleteTags: "Smazat tagy"
      },
      form: {
        language: "Jazyk",
        title: "Název",
        description: "Popis",
        group: "Skupina",
        groupPlaceholder: "Vybrat skupinu",
        addGroup: "Přidat",
        editingTranslations: "Úprava {{language}} překladů. Prázdná pole zobrazí obsah z {{defaultLanguage}}.",
        defaultValue: "Výchozí: {{value}}",
        image: "Obrázek",
        imageUrl: "URL obrázku"
      },
      actions: {
        save: "Uložit",
        deleteTag: "Smazat tag"
      },
              new: {
          title: "Přidat tag",
          messages: {
            createSuccess: "Tag byl úspěšně vytvořen",
            checkFields: "Prosím zkontrolujte svá pole"
          },
          actions: {
            createTag: "Vytvořit tag"
          }
        }
    },
    customFields: {
      title: "Vlastní pole",
      addField: "Přidat pole",
      error: "Chyba",
      resourceName: {
        singular: "Pole",
        plural: "Pole"
      },
      headings: {
        name: "Název",
        contentType: "Typ obsahu",
        usedIn: "Použito v"
      },
      emptyState: {
        heading: "Vytvořte a spravujte svá vlastní pole",
        createAction: "Vytvořit pole",
        description: "Používejte vlastní pole pro jedinečné atributy vašich lokalit. Tato pole mohou být cokoliv od sociálních profilů po jméno a e-mail manažera obchodu"
      },
      pluralization: {
        location: "lokalita",
        locations: "lokality"
      },
      form: {
        name: "Název",
        contentType: "Typ obsahu",
        key: "Klíč",
        keyPrefix: "location.fields.",
        keyHelp: "Použijte tento klíč pro přístup k obsahu {{name}} lokality ve vašich liquid šablonách.",
        translations: {
          title: "Překlady",
          showTranslations: "Zobrazit překlady",
          hideTranslations: "Skrýt překlady",
          description: "Překlady jsou volitelné. Prázdná pole zobrazí název pole {{language}}.",
          nameTranslation: "Název ({{language}})",
          defaultValue: "Výchozí: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Pole bylo úspěšně uloženo",
        couldntSave: "Pole se nepodařilo uložit",
        deletedSuccessfully: "Pole bylo úspěšně smazáno",
        couldntDelete: "Pole se nepodařilo smazat"
      },
      actions: {
        delete: "Smazat"
      },
      new: {
        title: "Přidat pole",
        messages: {
          savedSuccessfully: "Pole bylo úspěšně uloženo",
          couldntSave: "Pole se nepodařilo uložit"
        }
      },
      contentTypes: {
        text: "Text",
        textArea: "Textová oblast", 
        email: "E-mail",
        number: "Číslo",
        phoneNumber: "Telefonní číslo",
        time: "Čas",
        url: "URL"
      }
    },
    plan: {
      title: "Plán",
      error: "Chyba",
      changePlan: "Změnit plán",
      usdPerMonth: "USD / měsíc",
      sections: {
        yourPlanIncludes: "Váš plán zahrnuje",
        nextBillingDate: "Další datum fakturace",
        trial: "Zkušební verze"
      },
      banners: {
        planUpdated: "Váš plán byl aktualizován",
        thankYouUpgrading: "Děkujeme za upgrade!",
        letUsKnow: "Dejte nám vědět",
        improvementText: "pokud můžeme něco udělat lépe."
      },
      locations: {
        upTo: "Až",
        locations: "lokality",
        unlimited: "Neomezené lokality",
        used: "použito",
        ofUsed: "{{used}} z {{max}} použito"
      },
      trial: {
        daysLeft: "{{days}} dní zbývá",
        daysUsed: "{{used}} z {{total}} dní použito",
        selectPlan: "Vybrat plán",
        currentPlan: "Současný plán",
        trialBadge: "Zkušební verze",
        currentBadge: "Současný",
        yourTrialJustStarted: "Vaše zkušební verze právě začala",
        trialEndsAfterToday: "Vaše zkušební verze končí po dnešku",
        trialEndsTomorrow: "Vaše zkušební verze končí zítra",
        daysLeftInTrial: "{{days}} dní zbývá ve vaší zkušební verzi",
        continueAddingLocations: "Pokračujte v přidávání lokalit po {{date}} výběrem plánu",
        selectPlanToday: "Prosím vyberte dnes plán pro pokračování v přidávání lokalit"
      },
      footer: {
        description: "Spravujte nebo změňte svůj Locations So Super plán. Zobrazte naše",
        termsOfService: "podmínky služby",
        and: "a",
        privacyPolicy: "zásady ochrany osobních údajů"
      },
      features: {
        analytics: {
          title: "Analytika",
          description: "Zjistěte, jak lidé používají vaše lokality a kde hledají"
        },
        internationalization: {
          title: "Podpora více jazyků",
          description: "Zvyšte SEO a oslovte více zákazníků v cílových trzích povolením více jazyků"
        },
        customThemes: {
          editLiquid: {
            title: "Upravit liquid šablony témat",
            description: "Zobrazte data lokalit jakýmkoliv způsobem s přístupem k liquid tématům"
          },
          editStructuredData: {
            title: "Upravit strukturovaná data obchodu",
            description: "Upravte, jak Google rozumí stránkám úpravou vašich strukturovaných dat"
          }
        }
      },
      edit: {
        title: "Změnit plán",
        allPlansInclude: "Všechny plány výše zahrnují",
        needingMoreLocations: "Potřebujete více lokalit?",
        footerQuestion: "Máte nějaké otázky před začátkem?",
        sendMessage: "pošlete nám zprávu",
        allFeatures: {
          seoDirectory: {
            title: "SEO adresář a cílové stránky",
            description: "Automaticky vytvořte SEO adresář všech vašich lokalit, měst a regionů"
          },
          mapPage: {
            title: "Stránka mapy s vyhledáváním a filtrem",
            description: "Vyhledávejte a filtrujte všechny vaše lokality na mapě poháněné mapbox"
          },
          tags: {
            title: "Tagy",
            description: "Vytvářejte tagy s obrázky a popisy a seskupujte je"
          },
          openingHours: {
            title: "Otevírací doba",
            description: "Nastavte a zobrazte otevírací dobu pro vaše lokality"
          },
          mapStyles: {
            title: "Styly map",
            description: "Změňte vzhled map pomocí řady přednastavených stylů"
          },
          customFields: {
            title: "Vlastní pole",
            description: "Přidejte jakákoliv nová pole, která chcete, od sociálních odkazů po manažera obchodu"
          },
          csvUpload: {
            title: "Nahrávání a export pomocí CSV",
            description: "Nahrajte a hromadně upravujte své lokality."
          },
          richSnippets: {
            title: "Bohaté úryvky",
            description: "Pomozte Google lépe pochopit stránky pomocí strukturovaných dat místního podnikání"
          },
          directionsAndCalls: {
            title: "Navigace a volání",
            description: "Návštěvníci mohou snadno získat navigaci a volat do lokalit"
          },
          languageSupport: {
            title: "Jazyková podpora",
            description: "Změňte výchozí jazyk na něco jiného než angličtinu. Překladové šablony jsou poskytovány pro 32 hlavních jazyků pro snadné nastavení."
          }
        }
      },
      planCard: {
        bestToCustomize: "Nejlepší pro přizpůsobení",
        currentPlan: "Současný plán",
        chooseThisPlan: "Vybrat tento plán",
        locationsSection: "Lokality",
        featuresSection: "Funkce",
        upTo: "Až",
        locations: "lokality",
        tooltipTooManyLocations: "Máte příliš mnoho lokalit a/nebo povolených jazyků pro tento plán."
      },
      confirmation: {
        error: "Chyba při potvrzování plánu"
      }
    }
  },

  // Themes section
  themes: {
    title: "Motivy",
    currentTheme: {
      title: "Současný motiv",
      description: "Toto je motiv, který zákazníci vidí, když navštíví vaši aplikaci lokalit."
    },
    themeLibrary: {
      title: "Knihovna motivů", 
      description: "Spravujte motivy vašich lokalit. Přidávejte a publikujte motivy pro změnu vzhledu vaší online lokality."
    },
    skeleton: {
      currentThemeDescription: "Toto je motiv, který vaši zákazníci vidí, když používají vaši aplikaci lokalit."
    },
    modal: {
      overrideTitle: "Přepsat současný motiv?",
      override: "Přepsat",
      cancel: "Zrušit",
      undoWarning: "Tuto akci nelze vrátit zpět."
    },
    messages: {
      publishSuccess: "Motiv byl úspěšně publikován",
      publishError: "Motiv se nepodařilo publikovat",
      error: "Něco se pokazilo"
    },
    emptyStates: {
      settings: {
        heading: "Tento motiv nemá žádná nastavení",
        description: "Vytvořte nastavení v editoru šablon.",
        createSettings: "Vytvořit nastavení",
        upgradePlan: "Upgrade plánu",
        upgradeRequired: "Upgrade plánu pro vytvoření nastavení"
      },
      language: {
        heading: "Tento motiv nemá žádné jazykové termíny",
        description: "Vytvořte jazykové termíny v editoru šablon.",
        createLanguageTerms: "Vytvořit jazykové termíny",
        upgradePlan: "Upgrade plánu",
        upgradeRequired: "Upgrade plánu pro vytvoření jazykových termínů"
      }
    },
    templates: {
      categories: {
        templates: "Šablony",
        schemas: "Schémata",
        styles: "Styly",
        liquidReference: "Liquid reference"
      },
      items: {
        landing: "Cílová stránka",
        directory: "Adresář",
        country: "Země",
        region: "Region",
        city: "Město",
        location: "Lokalita",
        language: "Jazyk",
        settings: "Nastavení",
        stylesheet: "Styly"
      },
      errors: {
        errorsInTemplate: "Chyby v šabloně",
        error: "Chyba"
      },
      badges: {
        errors: "Chyby!",
        unsaved: "Neuloženo"
      },
      actions: {
        viewTheme: "Zobrazit motiv",
        discard: "Zahodit",
        save: "Uložit"
      }
    },
    language: {
      messages: {
        saveSuccess: "Jazykové překlady motivu byly úspěšně uloženy",
        saveError: "Motiv se nepodařilo uložit"
      },
      form: {
        language: "Jazyk",
        defaultLanguageHelp: "Toto je váš výchozí jazyk",
        translationHelp: "Úprava překladů pro {{selectedLocale}}. Prázdná pole zobrazí obsah z {{defaultLocale}} (váš výchozí jazyk)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Více jazyků není povoleno",
          action: "Povolit v nastavení",
          description: "Pro správu překladů pro více jazyků povolte internacionalizaci v jazykovém nastavení. Aktuálně se zobrazují pouze překlady {{locale}}."
        },
        translating: {
          title: "Překlad z {{from}} do {{to}}",
          description: "Jakékoliv pole, které necháte prázdné, automaticky zobrazí obsah {{defaultLocale}} vašim zákazníkům. Překládejte pouze pole, kde chcete jiný obsah v {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Přístup k jazykovým termínům {{category}} v liquid s {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Název",
        description: "Popis",
        heading: "Nadpis",
        subheading: "Podnadpis",
        button_text: "Text tlačítka",
        link_text: "Text odkazu",
        placeholder: "Zástupný text",
        label: "Označení",
        help_text: "Text nápovědy",
        error_message: "Chybová zpráva",
        success_message: "Zpráva o úspěchu",
        
        // Opening hours
        Monday: "Pondělí",
        Tuesday: "Úterý",
        Wednesday: "Středa",
        Thursday: "Čtvrtek",
        Friday: "Pátek",
        Saturday: "Sobota",
        Sunday: "Neděle",
        opening_hours_format: "Formát otevírací doby",
        closes_at_format: "Formát zavírací doby",
        opens_at_format: "Formát otevírací doby",
        opens_on: "Otevírá v",
        open_24h: "Otevřeno 24h",
        open: "Otevřeno",
        closed: "Zavřeno",
        closes_at: "Zavírá v",
        opens_at: "Otevírá v",
        
        // Map
        search_map: "Hledat na mapě",
        search_area: "Hledat v této oblasti",
        view_map: "Mapa",
        view_list: "Seznam",
        open_filters: "Filtry",
        stores_near_you: "Obchody ve vašem okolí",
        header: "Najděte obchod!",
        search_placeholder: "Zadejte PSČ nebo adresu...",
        no_listings: "Omlouváme se, nemůžeme najít žádné lokality pro vaše vyhledávání. Zkuste změnit filtry nebo vyhledávací lokalitu",
        
        // Directory
        view_directory: "Adresář obchodů",
        
        // Location
        get_directions: "Navigace",
        call: "Volat",
        view_website: "Webové stránky",
        email: "E-mail",
        opening_hours_header: "Otevírací doba",
        description_header: "Informace",
        phone_number_header: "Telefon",
        address_header: "Adresa",
        tag_groups_to_display: "Skupiny tagů k zobrazení"
      },
              categories: {
          // Common language categories - add specific ones as needed
          general: "Obecné",
          navigation: "Navigace",
          forms: "Formuláře",
          buttons: "Tlačítka",
          messages: "Zprávy",
          errors: "Chyby",
          opening_hours: "Otevírací doba",
          map: "Mapa",
          directory: "Adresář",
          location: "Lokalita"
        }
    },
    settings: {
      messages: {
        saveSuccess: "Téma bylo úspěšně uloženo",
        saveError: "Téma se nepodařilo uložit"
      },
      accessSettings: "Přístup k nastavení {{category}} v liquid s {{code}}",
      fields: {
        // Colors
        color_text: "Barva textu",
        color_text_heading: "Barva nadpisu textu", 
        color_background: "Barva pozadí",
        color_accent: "Barva akcentu",
        color_text_positive: "Barva pozitivního textu",
        color_text_negative: "Barva negativního textu",
        dark_theme: "Tmavé téma",
        color_marker: "Barva značky",
        color_search_marker: "Barva vyhledávací značky",
        
        // Typography
        base_font_size: "Základní velikost písma",
        
        // Buttons
        border_radius: "Poloměr okraje",
        
        // Images
        aspect_ratio: "Poměr stran",
        fit: "Přizpůsobit",
        
        // Spacing
        page_width: "Šířka stránky",
        page_width_small: "Malá šířka stránky",
        gutter_desktop: "Mezera desktop",
        gutter_mobile: "Mezera mobil",
        desktop_vertical_spacing: "Vertikální mezery desktop",
        mobile_vertical_spacing: "Vertikální mezery mobil",
        
        // Breakpoints
        breakpoint_xs: "Bod zlomu XS",
        breakpoint_sm: "Bod zlomu SM",
        breakpoint_md: "Bod zlomu MD",
        
        // Map
        search_on_move: "Hledat při pohybu",
        scroll_to_zoom: "Přiblížit rolováním",
        
        // Landing page
        sidebar_width: "Šířka postranního panelu",
        sidebar_min_height: "Minimální výška postranního panelu",
        marker_image_src: "Zdroj obrázku značky",
        show_filter_descriptions: "Zobrazit popisy filtrů",
        
        // Location page
        tag_groups_to_display: "Skupiny tagů k zobrazení",
        tag_groups_to_display_as_icons: "Skupiny tagů k zobrazení jako ikony",
        show_related_locations: "Zobrazit související lokality",
        
        // Locations
        hide_regions: "Skrýt regiony"
      },
              categories: {
          colors: "Barvy",
          typography: "Typografie",
          buttons: "Tlačítka",
          images: "Obrázky",
          spacing: "Mezery",
          breakpoints: "Body zlomu",
          map: "Mapa",
          landing_page: "Cílová stránka",
          location_page: "Stránka lokality",
          locations: "Lokality"
        }
    },
    navigation: {
      sublimeTheme: "Sublime Téma",
      settings: "Nastavení",
      language: "Jazyk",
      templates: "Šablony",
      changeTheme: "Změnit téma",
      viewDirectory: "Zobrazit adresář",
      viewLandingPage: "Zobrazit cílovou stránku"
    },
    card: {
      lastUpdated: "Naposledy aktualizováno",
      view: "Zobrazit",
      customize: "Přizpůsobit",
      publish: "Publikovat",
      actions: "Akce"
    }
  },

  // Analytics section
  analytics: {
    title: "Analytika",
    timePeriods: {
      last7days: "Posledních 7 dní",
      last30days: "Posledních 30 dní"
    },
    comparison: {
      compareToPrevious: "Porovnat s předchozím obdobím",
      stopComparing: "Zastavit porovnání s předchozím obdobím"
    },
    sections: {
      searchLocations: "Vyhledávání lokalit"
    },
    cards: {
      sessions: "Relace",
      topSearches: "Nejlepší vyhledávání",
      topLandingPageType: "Nejlepší typ cílové stránky",
      topPageViewsBySession: "Nejlepší zobrazení stránek podle relace",
      topLocations: "Nejlepší lokality",
      topReferrers: "Nejlepší odkazy",
      searches: "Vyhledávání",
      topLandingPagesBySession: "Nejlepší cílové stránky podle relace"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

}; 